/* eslint-disable max-len */
// Angular-cli uses the "production" attribute when building so make sure
// not to remove or rename it
// build-params is generated by gulp prior to build the app
import { buildParams } from './build-params';

export const environment: any = {
    production: true,
    environment: 'staging',
    currentSport: buildParams.sport,
    floEventHubBaseUrl: 'https://staging-admin.flowrestling.org',
    floArenaApiUrl: 'https://staging-floarena-api.flowrestling.org',
    flosportsApiBaseUrl: 'https://staging-api.flosports.tv',
    identityApiBaseUrl: 'https://staging-identity-api.flosports.tv',
    floCoreApiUrl: 'https://staging-api.flosports.tv/api',
    teamsOfUseUrl: 'http://www.flosports.tv/terms-and-conditions/',
    privacyPolicyUrl: 'http://www.flosports.tv/privacy/',
    googlePlacesApiKey: 'AIzaSyA5euksZhyEw6ksuFNR_phQOxYg-m4dSvQ',
    googleRecaptchaKey: '6Lco00AUAAAAAIzLUFuGYpqmnlK09zPbcduYPkpA',
    froalaEditorLicenseKey: 'YNB3fB2C10B8D6E5D2A-9UJHAEFZMUJOYGYQEa1c1ZJg1RAeF5C4C3F3E2C2C6D6D4C2==',
    downloadFloArenaUrl: 'https://floarena-apps.s3-us-west-2.amazonaws.com/index.html',
    rollbarClientToken: 'e64b03c401aa4bf48fe39f9a2ff53fe0',
    eventbriteWidgetsJsUrl: 'https://www.eventbrite.com/static/widgets/eb_widgets.js',
    stripe: {
        feePercentage: 2.9,
        feeAmount: 0.30,
        publishableKey: 'pk_test_CLqeKaWH0wVM5mENax8P7AII',
        clientId: 'ca_9BjjzqFDkXUVt0KdWmVHnk6faAoIjYch',
        oAuthUrl: 'https://connect.stripe.com/express/oauth/authorize',
        oAuthRedirectUri: 'https://staging-events.flowrestling.org/login/stripe-oauth',
    },
    sports: {
        flowrestling: {
            siteId: 2,
            identitySportGuid: '244ab390-a0cc-4fa9-8a81-6e59a72f6579',
            identitySportName: 'wrestling',
            participantAliasName: 'Wrestler',
            participantAliasNamePlural: 'Wrestlers',
            requireTeam: true,
            requireUsaWrestlingCardNumOption: true,
            collectNickname: false,
            collectWeight: true,
            collectDobOrGrade: true,
            collectWeightClass: true,
            collectSkillLevel: true,
            divisionProfiles: [
                '4E128DDE-DB80-4059-B800-5DCCD64F59B0',
                'BF9FAD43-6250-45E9-B136-AA4AD92FBF8E',
                'DA7A24D4-D9DB-4E21-B71A-A58280AF3858',
                'DDF2EC43-FDC4-4213-A61F-F991ADDD025D',
                '6e59959d-8208-4b66-a6ba-19777d7783c2',
                'c2c15942-cbbb-4341-b2b0-08e645595a2c',
                'C2976C28-0FAB-48DE-A2A6-40C423000839',
                '5483294D-F804-4796-8368-132E6DEAAE89',
                // other folkstyle
                '5e78ab46-9b27-4d12-bc5e-465f669ed483',
                // youth folkstyle
                '24f8744e-be96-4fc5-b0ff-3c094170788c',
            ],
            floProSignup: {
                title: 'Add FloPRO to your account now for instant access<br/>to the best wrestling content on the planet!',
                streamingTitle: 'This event will be live streamed on FloPRO!<br/>Add it to your account to watch and get instant access' +
                ' to more great wrestling content.',
                payUrl: 'https://staging-public.flowrestling.org/pay?next=/',
                valueProps: [
                    {
                        iconClass: 'fas fa-stack-1x fa-video',
                        title: 'Live & Archived Event Videos',
                        description: 'Top Wrestling Meets and Tournaments in the U.S.',
                    },
                    {
                        iconClass: 'fas fa-stack-1x fa-file-alt',
                        title: 'Original<br/>Documentaries',
                        description: 'David Taylor, Mark Perry, Mark Hall, Kyle Dake & More',
                    },
                    {
                        iconClass: 'fas fa-stack-1x fa-play',
                        title: 'Technique<br/>Video Library',
                        description: 'Instruction from All-Americans, Olympians & More',
                    },
                ],
            },
            header: {
                siteUrl: 'http://staging-public.flowrestling.org',
                accountUrl: 'https://staging-public.flowrestling.org/settings',
                signUpUrl: 'https://staging-public.flowrestling.org/signup',
                searchUrl: 'http://staging-public.flowrestling.org/search?q=',
            },
        },
        flograppling: {
            siteId: 8,
            name: 'FloGrappling',
            identitySportGuid: 'fc049c95-84c7-4bab-8bc0-b4e7c4a0cc45',
            identitySportName: 'grappling',
            participantAliasName: 'Fighter',
            participantAliasNamePlural: 'Fighters',
            requireTeam: true,
            requireUsaWrestlingCardNumOption: false,
            collectNickname: false,
            collectWeight: true,
            collectDobOrGrade: true,
            collectWeightClass: true,
            collectSkillLevel: true,
            divisionProfiles: [
                'E2FD8A53-6414-4286-95F4-49B268441A56',
                'AC3F8177-1F0F-4D01-9CA8-872F73AC319F',
                '6B8679CA-D154-4821-899B-DAC61DDB0687',
                '4678a946-d3d4-42d7-a0c5-cdf140818f3c',
                '3709BB26-F9A3-4DD0-ACE1-CEE571AC26C9',
            ],
            floProSignup: {
                title: 'Add FloPRO to your account now for instant access<br/>to the best grappling content on the planet!',
                streamingTitle: 'This event will be live streamed on FloPRO!<br/>Add it to your account to watch and get instant access' +
                ' to more great grappling content.',
                payUrl: 'https://staging-public.flograppling.com/pay?next=/',
                valueProps: [
                    {
                        iconClass: 'fas fa-stack-1x fa-video',
                        title: 'Live & Archived Event Videos',
                        description: 'Top International Grappling Events Including multiple IBJJF events with Multiple Camera Angles',
                    },
                    {
                        iconClass: 'fas fa-stack-1x fa-file-alt',
                        title: 'Original<br/>Documentaries',
                        description: 'Romulo Barral, Edwin Najmi, Eddie Bravo, Caio Terra, Cyborg Abreu, Atos!',
                    },
                    {
                        iconClass: 'fas fa-stack-1x fa-play',
                        title: 'Technique<br/>Video Library',
                        description: 'Technique and Instruction Videos from Top Brazilian Jiu-Jitsu Athletes Including Dean Lister',
                    },
                ],
            },
            header: {
                siteUrl: 'http://staging-public.flograppling.com',
                accountUrl: 'https://staging-public.flograppling.com/settings',
                signUpUrl: 'https://staging-public.flograppling.com/signup',
                searchUrl: 'http://staging-public.flograppling.com/search?q=',
            },
        },
    },
};
